export default __webpack_public_path__ + "static/media/bi.5adb2c0e.png";